/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChatControllerGetRequestStatusQueryResponse, ChatControllerGetRequestStatusPathParams, ChatControllerGetRequestStatus401, ChatControllerGetRequestStatus403, ChatControllerGetRequestStatus404 } from "../../models/chatController/ChatControllerGetRequestStatus";

function getChatControllerGetRequestStatusUrl(requestId: ChatControllerGetRequestStatusPathParams["requestId"]) {
  const res = { method: 'GET', url: `/api/v1/chat/status/${requestId}` as const }  
  return res
}

/**
 * @summary Get status of a chat request
 * {@link /api/v1/chat/status/:requestId}
 */
export async function chatControllerGetRequestStatus(requestId: ChatControllerGetRequestStatusPathParams["requestId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ChatControllerGetRequestStatusQueryResponse, ResponseErrorConfig<ChatControllerGetRequestStatus401 | ChatControllerGetRequestStatus403 | ChatControllerGetRequestStatus404>, unknown>({ method : "GET", url : getChatControllerGetRequestStatusUrl(requestId).url.toString(), ... requestConfig })  
  return res.data
}